module.exports = __webpack_public_path__ + "f27d621963473cafea9206ac278eae89.svg";